import { render, staticRenderFns } from "./LoginContent.vue?vue&type=template&id=08f07344&"
import script from "./LoginContent.vue?vue&type=script&lang=js&"
export * from "./LoginContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports